import React from "react";
import Accordion from "../../components/Accordion/Accordion";
import Profile from "../../components/profile/profile";
import { userDataState } from "../../atoms/dashboard";
import { certifications, empSkill } from "../../selectors/dashboard";
import { useRecoilValue } from "recoil";
import { priSkillsSel } from "../../selectors/dashboard";
import { mySkillUrl } from "../../selectors/baseurl";
const Dashleft = () => {
  const usrData = useRecoilValue(userDataState);

  const { priSkill: primarySkills, secSkill: secondarySkills } = useRecoilValue(
    empSkill
  );
  const certificateData = useRecoilValue(certifications);

  console.log("certificateData", certificateData);

  console.log("primarySkills", primarySkills);
  console.log("secondarySkills", secondarySkills);

  const accodionData = {
    title: "Primary",
    className: "skill_accordion",
    // primary: [
    //   // ["Primary",  <img src={AccordionArrow} class="transition group-open:rotate-180 float-right" />],
    //   ["Skills (3)", "Proficiency"],
    //   ["MS Office 2012 - Presentation", "Expert"],
    //   ["MS Office 2012 - Word & Excel", "Expert"],
    //   ["Photoshop", "Expert"],
    //   ["MS Office 2012 - Presentation", "Expert"],
    //   ["MS Office 2012 - Word & Excel", "Expert"],
    //   ["Photoshop", "Expert"],
    // ],
    primary: primarySkills,
  };

  const accodionData1 = {
    title: "Secondary",
    className: "skill_accordion",
    // secondary: [
    //   //["Secondary", <img src={AccordionArrow} class="transition group-open:rotate-180 float-right" />],
    //   ["Skills (3)", "Proficiency"],
    //   ["MS Office 2012 - Presentation", "Expert"],
    //   ["MS Office 2012 - Word & Excel", "Expert"],
    //   ["Photoshop", "Expert"],
    // ],
    secondary: secondarySkills,
  };

  const certification = {
    title: "My Certifications",
    // primary: [
    //   ["Type", "Certification", "Action"],
    //   ["Internal", "Microsoft Office Basic", "View"],
    // ],
    primary: certificateData,
  };

  const profileData = [
    {
      id: "1",
      avatarImg:
        "https://myconnect-pages.rrd.com/IconnectReader/iConnectUploadData/EMPPhotoNew/" +
        usrData?.empID +
        ".JPG",
      profileName: usrData?.employeeName,
      designation:
        usrData?.jobTitleName + " " + "(" + usrData?.jobLevelName + ")",
      stream: usrData?.streamName,
      division: usrData?.divisionName,
      position: "horizontal",
      showStream: "yes",
      imageClassName: "avatar-img",
      dataClassName: "avatar-data",
    },
  ];
  const handleButtonClick = () => {
    // Specify the URL you want to open
    const url = mySkillUrl;
    
    // Open the URL in a new tab
    window.open(url, '_blank');
};
  return (
    <>
      <Profile data={profileData} />
      <button className="bg-[#033d9b] uppercase text-white py-1 px-3 rounded-full font-medium text-[10px] mr-2 mt-2" onClick={handleButtonClick}>Access your Skill(s)</button>
      <div className="prisecskills">
        <Accordion clsName={accodionData.className} data={accodionData} from={"primary"}/>
        <Accordion clsName={accodionData.className} data={accodionData1} />
      </div>

     
      <div className="ceretCls">
        <Accordion data={certification} from={"certificate"} />
      </div>
    </>
  );
};

export default Dashleft;
